module.exports = __webpack_public_path__ + "img/admin1.c506e6ff.png";